import React from 'react';
import styled, { keyframes } from 'styled-components';

const getBlock = (type) => {
  switch (type) {
    case 'gold':
      return GoldBlock;
    case 'silver':
      return SilverBlock;
    case 'copper':
      return CopperBlock;
    default:
      return CopperBlock;
  }
};

const getRandomRotation = () => {
  const degrees = Math.floor(Math.random() * 15);
  const sign = Math.random() > 0.5 ? 1 : -1;

  return degrees * sign;
};

const getRandomDisplacement = () => {
  const displacement = Math.floor(Math.random() * 5);
  const sign = Math.random() > 0.5 ? 1 : -1;

  return displacement * sign;
};

const ResourceBlock = (props) => {
  const type = props.type;

  const Block = getBlock(type);

  return (
    <Container blockSize={props.blockSize}>
      <Block
        blockSize={props.blockSize}
        rot={getRandomRotation()}
        deltaX={getRandomDisplacement()}
        deltaY={getRandomDisplacement()}
      />
    </Container>
  );
};

const rock = keyframes`
  0% {
    transform: rotate(-5deg);
  }
  50% {
    transform: rotate(5deg);
  }
  100% {
    transform: rotate(-5deg);
  }
`;

const copperRatio = 0.9;
const silverRatio = copperRatio * 1.2;
const goldRatio = copperRatio * 1.4;
const containerRatio = copperRatio * 1.5;

const Container = styled.div`
  padding: 25%;
  animation: ${rock} 2s infinite;
  display: grid;
  place-items: center;
  height: ${(props) => props.blockSize * containerRatio}px;
  width: ${(props) => props.blockSize * containerRatio}px;
`;

const Block = styled.div`
  border-radius: 6px;
  box-shadow: 3px 3px 5px 1px rgba(0, 0, 0, 0.7);
  border: 3px solid black;
  transform: rotate(${(props) => props.rot}deg)
    translate(${(props) => props.deltaX}px, ${(props) => props.deltaY}px);
`;

const GoldBlock = styled(Block)`
  background: linear-gradient(to bottom right, yellow, #bf953f, yellow);
  height: ${(props) => props.blockSize * goldRatio}px;
  width: ${(props) => props.blockSize * goldRatio}px;
`;
const SilverBlock = styled(Block)`
  background: linear-gradient(to bottom right, white, #9f9f9f, white);
  height: ${(props) => props.blockSize * silverRatio}px;
  width: ${(props) => props.blockSize * silverRatio}px;
`;
const CopperBlock = styled(Block)`
  background: linear-gradient(to bottom right, #ffd, #ff953f, #ffd);
  height: ${(props) => props.blockSize * copperRatio}px;
  width: ${(props) => props.blockSize * copperRatio}px;
`;

export default ResourceBlock;
